export default __webpack_public_path__ + "4c2ebeea9c94130d56e976a5195de7a8.png";